export type Role = 'viewer' | 'reviewer' | 'admin';

export interface Me {
  email: string;
  name: string;
  role: Role;
}

export async function fetchMe(): Promise<Me | null> {
  const res = await fetch('/auth/me', { credentials: 'include' });
  if (res.status === 401) return null;
  if (!res.ok) throw new Error(`/auth/me returned ${res.status}`);
  return res.json() as Promise<Me>;
}
